import { FormEvent, useEffect, useState } from "react";
import { IPaginacionComponent } from "../../Interfaces/filter";
import { DefaultButton, Dropdown, IDropdownOption, Label, Spinner, SpinnerSize, Tooltip } from "@fluentui/react";
import { FlechaMayor, FlechaMenor } from "../../utils/IconsSVG";
import { skip } from "node:test";
const MENU_ITEMS_PAGINACION = [
    { key: "10", text: "10 Items" },
    { key: "50", text: "50 Items" },
    { key: "100", text: "100 Items" },
]
export const PaginationComponent = (props: IPaginacionComponent) => {
    const [skipPagination, setSkipPagination] = useState<number>(props.skipPagination??0)
    useEffect(()=>{
        if(props.skipPagination==0 &&skipPagination!=0){
            setSkipPagination(0)
        }
    },[props.skipPagination])

    const onCheckedValueChange = (event:FormEvent<HTMLDivElement>, data?: IDropdownOption) => {
        const ver = (data==null?"0":data.key).toString()
        if (props.onChangeTake) props.onChangeTake(Number.parseInt(ver));
    };
    const handleClick = (text: string) => {
        let newSkip;
        switch (text) {
            case "Inicio":
                newSkip = 0;
                break;
            case "Anterior":
                newSkip = Math.max(0, skipPagination - (props.takePagination??0));
                break;
            case "Siguiente":
                newSkip = skipPagination + (props.takePagination??0);
                break;
            case "Último":
                newSkip = (props.totalPagesPagination??1 - 1) * (props.takePagination??0) -(props.takePagination??0);
                break;
            default:
                break;
        }
        setSkipPagination(newSkip);
        if (props.onChangeSkip) props.onChangeSkip(newSkip);
    };
    return (
        <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: 'center'
        }}>
            <div style={{ display: 'flex' }}>
                {props.isLoading ? <Spinner size={SpinnerSize.small} /> : props?.cantidad}
                <Label style={{
                    padding: '0px 5px'
                }}>
                    {' items de '}
                </Label>
                {props.isLoading ? <Spinner size={SpinnerSize.small} /> : props?.total}
            </div>
            <div style={{ display: "flex", alignItems: 'center' }}>
            {props.isLoading ? <Spinner size={SpinnerSize.small} /> : (
                <div key={"menu"}>
                <Dropdown style={{width:'300px'}}
                selectedKey={  MENU_ITEMS_PAGINACION.find(item => parseInt(item.key) === (props.takePagination??0))?.key}
                onChange={onCheckedValueChange}
                options={MENU_ITEMS_PAGINACION.map(item => ({
                text: `Registros por página | ${item.text}`,
                value: item.key,
                key: item.key
                 }))}
                 />
                   
                 </div>)}

                <div key={"descripcion"} style={{ display: 'flex' }}>
                    <Label
                        style={{
                            padding: '0px 5px',
                        }}
                    >
                        {props.isLoading ? <Spinner typeof='small' /> : `Página ${props.actualPage}  de`}
                    </Label>
                    {props.isLoading ? <Spinner size={SpinnerSize.small} /> : props.totalPagesPagination}
                </div>
                <div key={"opciones"}>
                    <>
                        
                            <DefaultButton id="cosalo"
                                iconProps={{iconName:'Previous'}}
                                disabled={props.actualPage == 1 || props.actualPage==0}
                                onClick={() => handleClick("Inicio")}
                                style={{
                                    background: "#ffff",
                                    border: "none",
                                }}
                               
                            />
                       
                       
                            <DefaultButton
                                
                                disabled={props.actualPage == 1|| props.actualPage==0}
                                onClick={() => handleClick("Anterior")}
                                style={{
                                    background: "#ffff",
                                    border: "none",
                                }}
                            >
                            <FlechaMayor fill={`${props.actualPage === 1 || props.actualPage==0 ? "#bdbdbd" : ""}`} />
                            </DefaultButton>
                       
                        
                            <DefaultButton
                                disabled={props.actualPage == props.totalPagesPagination||props.actualPage==0}
                                onClick={() => handleClick("Siguiente")}
                                style={{
                                    background: "#ffff",
                                    border: "none",
                                }}
                            >
                            <FlechaMenor fill={`${props.actualPage === props.totalPagesPagination||props.actualPage==0 ? "#bdbdbd" : ""
                                    }`} />
                            </DefaultButton>
                   
                    </>
                    <>
                       
                            <DefaultButton
                                iconProps={{iconName:'Next'}}
                                disabled={props.actualPage == props.totalPagesPagination||props.actualPage==0}
                                onClick={() => handleClick("Último")}
                                style={{
                                    background: "#ffff",
                                    border: "none",
                                }}
                            />
                        
                    </>
                </div>
            </div>
        </div>

    );

    
}